// extracted by mini-css-extract-plugin
module.exports = {"innerContainer":"MobileCard_innerContainer__3C3F5","container":"MobileCard_container__2bNyp"};